import BlueBadge from "../../../../components/common/AdminCommonComponents/BlueBadge/BlueBadge"
import BlueTableHeading from "../../../../components/common/AdminCommonComponents/BlueTableHeading/BlueTableHeading"
import ActionButton from "../../../../components/common/AdminCommonComponents/Buttons/ActionButton/ActionButton"
import DynamicDatatable from "../../../../components/common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import DynamicTableFilters from "../../../../components/common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters"
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow"
import StatusBadge from "../../../../components/common/AdminCommonComponents/StatusBadge/StatusBadge"

const ProductApprovalQueue = () => {
  const cardsData = [
    { title: "Total products awaiting approval".toUpperCase(), value: 0 },
    { title: "Urgent Review alerts".toUpperCase(), value: 0 },
    { title: "Average approval time".toUpperCase(), value: 0 },
  ]

  const actions = [
    { label: 'Delist Product', action: () => {} },
    { label: 'Product detail', action: () => {} },
    // { label: 'Delete', action: () => {} },
  ]

  const tableData = [
    { sr: '1', productId: '#766544', productName: 'Lorem Ipsum', category: 'Apparel & Accessories', sellerId: '#6567', currentStock: '101', lowStockThreshold: '02/01/2025', stockStatus: 'Approved' },
    { sr: '1', productId: '#766544', productName: 'Lorem Ipsum', category: 'Apparel & Accessories', sellerId: '#6567', currentStock: '10', lowStockThreshold: '02/01/2025', stockStatus: 'In-stock' },
    { sr: '1', productId: '#766544', productName: 'Lorem Ipsum', category: 'Apparel & Accessories', sellerId: '#6567', currentStock: '101', lowStockThreshold: '02/01/2025', stockStatus: 'Approved' },
    { sr: '1', productId: '#766544', productName: 'Lorem Ipsum', category: 'Apparel & Accessories', sellerId: '#6567', currentStock: '10', lowStockThreshold: '02/01/2025', stockStatus: 'In-stock' },
    { sr: '1', productId: '#766544', productName: 'Lorem Ipsum', category: 'Apparel & Accessories', sellerId: '#6567', currentStock: '101', lowStockThreshold: '02/01/2025', stockStatus: 'Approved' },
  ]

  const columns = [
    { name: 'Sr.', selector: (row) => row.sr, grow: 0.5 },
    { name: 'Product ID', selector: (row) => row.productId },
    { name: 'Product Name', selector: (row) => row.productName },
    { name: 'Category', selector: (row) => row.category },
    { name: 'Seller ID', selector: (row) => row.sellerId },
    { name: 'Current Stock', cell: (row) => <BlueBadge>{row.currentStock}</BlueBadge>, center: 'true' },
    { name: 'Low-Stock Threshold', selector: (row) => row.lowStockThreshold },
    { name: 'Stock Status', selector: (row) => <StatusBadge statusName={row.stockStatus} /> },
    { name: 'Action', cell: () => <ActionButton options={actions}/>, center: 'true'}
  ]

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f2f2f2", padding: "1rem" }}>
      <div className="shadow bg-white p-3">
        <div className="mb-3 fw-semibold fs-4">Product Approval Queue</div>
        <DynamicCardRow cards={cardsData} />
      </div>

      <div className="bg-white shadow mt-3">
        <BlueTableHeading className='px-4 py-3 fw-semibold fs-5'>Product Approval Queue</BlueTableHeading>

        <DynamicTableFilters componentName='Product Approval Queue' />

        <div className="p-3">
          <DynamicDatatable data={tableData} columns={columns} type="gray" pagination />
        </div>
      </div>
    </div>
  )
}

export default ProductApprovalQueue
